import { render, staticRenderFns } from "./ApprovalDocument.vue?vue&type=template&id=751cb054&scoped=true&"
import script from "./ApprovalDocument.vue?vue&type=script&lang=js&"
export * from "./ApprovalDocument.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDocument.vue?vue&type=style&index=0&id=751cb054&lang=scss&scoped=true&"
import style1 from "./ApprovalDocument.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751cb054",
  null
  
)

export default component.exports